import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DailyReportService } from '../../../../daily-report.service';

/**
 * Right-panel wrapper for the generic form renderer — mirrors
 * ControlFormDetailsWrapperComponent so the existing actions-section
 * (save/delete/location/comment) drives the generic form via the shared
 * DailyReportService subjects.
 */
@Component({
  selector: 'app-generic-form-wrapper',
  templateUrl: './generic-form-wrapper.component.html',
  styleUrls: ['./generic-form-wrapper.component.scss'],
  standalone: false,
})
export class GenericFormWrapperComponent implements OnInit, OnDestroy {
  @Input() data: any;
  disableAddMenu = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private dailyReportService: DailyReportService) {}

  ngOnInit() {
    this.dailyReportService.disableAddMenu
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        this.disableAddMenu = d;
      });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
